import moment from 'moment';
import _ from 'lodash';

Date.prototype.isValid = function () {
  return this.getTime() === this.getTime();
};

moment.updateLocale('pt-BR');

export const formatHour = hour => moment.utc(moment.duration(hour).asMilliseconds()).format('HH:mm');

export const formatSeconds = hour => moment.duration(hour).asSeconds();

export const secondsToHours = time => {
  const duration = moment.duration(time, 'seconds').asSeconds();
  const result = moment.utc(duration * 1000).format('HH:mm');
  return result;
};

export const totallyHours = time => {
  const dur = moment.duration(time, 'seconds');
  const hours = Math.floor(dur.asHours());
  const mins = Math.floor(dur.asMinutes()) - hours * 60;
  const result = `${hours > 9 ? hours : `0${hours}`}:${mins > 9 ? mins : `0${mins}`}`;
  return result;
};

export const formatDate = (date, format) => {
  try {
    const newDate = new Date(moment(date));
    const dateSuccess = moment(newDate).format(format || 'DD/MM/YYYY');
    if (newDate.isValid()) return dateSuccess;
    return new Date();
  } catch (e) {
    const dateError = new Date();
    return dateError;
  }
};

export const sumHours = (arr, key) => {
  if (!arr || arr.length <= 0) return '00:00';
  const workedHours = _.sumBy(arr, key);
  return totallyHours(workedHours);
};

export const diffHours = (first, second) => {
  const f = moment(first, 'hh:mm');
  const s = moment(second, 'hh:mm');
  const result = f.diff(s);
  return result;
};

export const ProjectNames = (arr, name) => {
  if (!arr) return;
  const result = arr.filter(item => item.nome === name);
  return result.length > 0;
};

export const triggerHour = (hour, trigger) => {
  const time = secondsToHours(hour);
  const diff = diffHours(time, trigger ?? '08:30');
  const result = moment.duration(diff).asMinutes();
  return result;
};

export const debounce = (func, wait) => {
  let timer = null;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(func, wait);
  };
};

export const dayOfWeek = day => {
  const date = new Date(day);
  return date.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
};

export const monthYear = date => {
  const result = date ? moment(date).format('MMYYYY') : '';
  return result;
};

export const diffDate = day => {
  const date = moment(day).format('DD/MM/YYYY');
  const today = moment().format('DD/MM/YYYY');
  return date !== today;
};

export const isToday = date => moment(date).isSame(new Date(), 'day');

export const isSameDate = (first, second) => moment(first).isSame(second, 'day');
export const isSameMonth = (first, second) => moment(first).isSame(second, 'Month');

export const isSameOrBefore = (first, last) => {
  const initialDate = moment(first);
  const finalDate = moment(last);
  const test = initialDate.isSameOrBefore(finalDate);
  return test;
};
